import CreateDamageForm from "./CreateDamageForm";
import ShowLeasysResults from "./ShowLeasysResults";
import ExportDamageForms from "./ExportDamageForms";
import ExportAccidentsFromLeasys from "./ExportAccidentsFromLeasys";

const Dialogs = {
  CreateDamageForm,
  ShowLeasysResults,
  ExportDamageForms,
  ExportAccidentsFromLeasys
}

export default Dialogs;